<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="'Review and Submit'"            
            v-bind:titleRef="'titleElementReviewandSubmit'">
        </MdTitleRegInfo>

    <p class="iSetupLabel">
        <i class="ikon med-help"></i>
        After filling in all the required information, review your entries carefully. When you're ready, <b>Submit</b> your data to MedEZ<sup>®</sup>.
    </p>
    <vue-good-wizard 
      ref="iwizard"
      :steps="steps"
      :finalStepLabel="$t('treatmentplan.finish')" 
      :nextStepLabel="$t('treatmentplan.Next')"
      :previousStepLabel="$t('Shared.Back')"     
      :onNext="nextClicked" 
      :onBack="backClicked"
      >    
      <div slot="company">        
  
      </div>
      <div slot="providers">

      </div>
      <div slot="roles">
       
      </div>
      <div slot="users">

      </div>
      <div slot="programs">
 
      </div>     
      <div slot="notes">
       
     </div> 
      <div slot="therapies">
       
     </div>
      <div slot="appointments">
       
     </div>
     <div slot="submit">
       
     </div>
    </vue-good-wizard>



    </div>
   

</template>

<script>

export default {
  name: 'IniReviewandSubmit',
  data(){
    return{
         steps: [
                {
                    label: 'Company',
                    slot: 'company',
                },
                {
                    label: 'Providers',
                    slot: 'providers',
                },
                {
                    label: 'Roles',
                    slot: 'roles',
                },
                {
                    label: 'Users',
                    slot: 'users',
                },
                {
                    label: 'Programs',
                    slot: 'programs',
                },
                {
                    label: 'Notes',
                    slot: 'notes',
                },
                {
                    label: 'Therapies',
                    slot: 'therapies',
                },
                {
                    label: 'Appointments',
                    slot: 'appointments',
                },
                {
                    label: 'Submit',
                    slot: 'submit',
                }
            ],
    }
  },
  methods:{
  Back(){
        this.$router.push({ name:'iapptypes'}); 
    },
    nextClicked(currentPage){
        if (currentPage === 0) {
            return true;
        }else if(currentPage === 1){
            return true;
        }else if(currentPage === 2){
            return true;
        }else if(currentPage === 3){
            return true;
        }else if(currentPage === 4){
            return true;
        }else if(currentPage === 5){
            return true;
        }else if(currentPage === 6){
            return true;
        }else if(currentPage === 7){
            return true;
        }else if(currentPage === 8){
            return true;
        }
    },
    backClicked(){
         return true; 
    }
  },
  mounted(){

  }   
};
</script>


